import axios from 'axios'
export default {
  methods: {
    async selectProv () {
      try {
        const provList = await axios.get('member/listprovinsi')
        this.provinceList = provList.data
      } catch (err) {
        this.logger(err)
      }
    }
  }
}
